import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useShop } from '../context/ShopContext';
import Sidebar from "./Sidebar";




const Employee = () => {
    const [employees, setEmployees] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(""); 
    const [salaryAmount, setSalaryAmount] = useState("");
    const [salaryDate, setSalaryDate] = useState(new Date().toISOString().split("T")[0]);
    const [isSubmitting, setIsSubmitting] = useState(false);  // ✅ Button disable karne ka state
    const { shopId } = useShop();





const showToast = (message, type = "error") => {
              toast.dismiss(); // Dismiss any existing toast before showing a new one
            
              console.log("Toast Type:", type); // Debugging log to check type value
            
              if (type.toLowerCase() === "error") {
                toast.error(message);
              } else if (type.toLowerCase() === "success") {
                toast.success(message);
              } else {
                console.warn("Invalid toast type:", type);
              }
            };













    const fetchEmployees = async () => {
        try {
            const response = await axios.post(
                "https://winenew.sipstocks.in/api/Liquor/GetEmployee",
                { shopId },
                { headers: { "Content-Type": "application/json" } }
            );

            console.log("fetchEmployees Response:", response.data);

            if (response.data.code === 200) {
                setEmployees(response.data.data || []);
            } else {
                showToast("Failed to fetch employees","error");
            }
        } catch (error) {
            showToast("Error fetching employees","error");
            console.error("API Error:", error);
        }
    };

    const handleSubmit = async () => {
        if (!selectedEmployeeId || !salaryAmount || !salaryDate) {
            showToast("Please fill in all fields.","error");
            return;
        }

        setIsSubmitting(true); // ✅ Button disable karna

        const formattedDate = new Date(salaryDate).toISOString();
        const requestData = {
            employeeId: Number(selectedEmployeeId),
            shopId: Number(shopId),
            salaryDate: formattedDate,  
            amount: Number(salaryAmount)  
        };

        console.log("Sending Request Data:", requestData);

        try {
            const response = await axios.post(
                'https://winenew.sipstocks.in/api/Liquor/SaveSalary',
                requestData,
                {
                    headers: {
                        'accept': '*/*',
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log("SaveSalary API Response:", response.data);

            if (response.data.code === 200) {
                showToast("Salary submitted successfully!","success");
                setTimeout(() => window.location.reload(), 2000);
                setSelectedEmployeeId("");
                setSalaryAmount("");
                setSalaryDate(new Date().toISOString().split("T")[0]);
            } else {
                showToast(response.data.message || "Failed to submit salary.","error");
            }
        } catch (error) {
            console.error("API Error:", error.response?.data || error.message);
            showToast(`Error submitting salary: ${error.response?.data?.message || error.message}`,"error");
        }

        setIsSubmitting(false); // ✅ API response aane ke baad button enable karna
    };

    useEffect(() => {
        fetchEmployees();
    }, [shopId]);

    const filteredEmployees = employees.filter(employee =>
        employee.employeeName?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
     <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
       {/* Content wrapper */}
       <div className="d-flex flex-column flex-column-fluid">
           {/* Toolbar */}
           <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
               {/* Toolbar container */}
               <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                   {/* Page title */}
                   <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                       {/* Title */}
                       <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                       Enter Employee Salary
                       </h1>
                       <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                           <li className="breadcrumb-item text-muted">
                               <a href="index.html" className="text-muted text-hover-primary">Home</a>
                           </li>
                           <li className="breadcrumb-item">
                               <span className="bullet bg-gray-500 w-5px h-2px"></span>
                           </li>
                           <li className="breadcrumb-item text-muted">Dashboards</li>
                       </ul>
                   </div>
               </div>
           </div>
     
           <div id="kt_app_content" className="app-content flex-column-fluid">
               <div id="kt_app_content_container" className="app-container container-fluid">
                   <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                       <div className="col-xl-12">
                           <div className="card card-flush h-md-100">
                              <ToastContainer />
                             
                               <div className="card-body pt-6">
                                   <div className="table-responsive">
                                       <div className="panel-body">
                                           <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                               {/* <form className="form-inline">
                                                   <div className="form-group">
                                                       <p className="form-control-static">Search Products:</p>
                                                   </div>
                                                   <div className="form-group d-flex justify-content-between gap-5">
                                                       <label htmlFor="inputsearch" className="sr-only active">Search Products</label>
                                                       <input className="form-control" id="inputsearch" placeholder="Search Products" type="text" value="" autoComplete="off" />
                                                       <button type="submit" className="btn btn-info mt-3">Search</button>
                                                   </div>
  
                                               </form> */}
                                           </div>
                                           <div className="clearfix"></div>
                                           <br />
  
         <div className="table-responsive  h-400px">
     
<table className="table table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Employee</th>
                                                        <th>Date</th>
                                                        <th>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <select
                                                                value={selectedEmployeeId}
                                                                onChange={(e) => {
                                                                    console.log("Selected Employee ID:", e.target.value);
                                                                    setSelectedEmployeeId(e.target.value);
                                                                }}
                                                                className="form-control"
                                                            >
                                                                <option value="">Select Employee</option>
                                                                {filteredEmployees.length > 0 ? (
                                                                    filteredEmployees.map((employee) => (
                                                                        <option key={employee.id} value={employee.id}>
                                                                            {employee.employeeName}
                                                                        </option>
                                                                    ))
                                                                ) : (
                                                                    <option disabled>No Employees Found</option>
                                                                )}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="date"
                                                                value={salaryDate}
                                                                onChange={(e) => setSalaryDate(e.target.value)}
                                                                className="form-control"
                                                            />
                                                        </td>
                                                        <td>
                                                        <input
  type="text"
  value={salaryAmount}
  min="1"
  onKeyDown={(e) => {
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
  }}
  onChange={(e) => {
    const value = e.target.value;
    if (value === "" || Number(value) > 0) {
      setSalaryAmount(value);
    } else {
      showToast("Salary amount must be greater than 0!", "error");
    }
  }}
  className="form-control"
  placeholder="Enter Amount"
/>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

 </div>
                                            
   
   
   
                                             <div class="text-right align-items-right d-flex justify-content-end">
        
                                             <button type="submit" className="btn btn-info mt-3 m-2"    onClick={handleSubmit}disabled={isSubmitting}   > {isSubmitting ? "Submitting..." : "Submit"}</button>  

 </div>
 
   
 
                          
                             {/* Submit Button */}

    
   
   
                                             
                                       </div>
                                       
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>
     
       {/* Footer */}
       <div id="kt_app_footer" className="app-footer">
           <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
               <div className="text-gray-900 order-2 order-md-1">
                   <span className="text-muted fw-semibold me-1">2025&copy;</span>
                   <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
               </div>
           </div>
       </div>
   
     
     
     
     
     
     
     
 
     
    
     
     
     
     
     
    
     
   
     
     </div>
    );
};

export default Employee;
